import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import StripeCheckout from 'react-stripe-checkout';
import './AmountBox.scss';

function AmountBox(amount) {
  let paymentData;
  // let amount;
  const total = parseInt(amount.total);

  const makePayment = (token) => {
    const body = {
      token,
      amount,
    };

    return fetch('http://localhost:8080/payment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((resData) => {
        console.log(resData);
        paymentData = resData;
        console.log('Payement Done');
        console.log(amount.total);
        // window.location.replace('/recipt');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const history = useHistory();
  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);

  console.log('payment:', paymentData);

  return (
    <div className="amount-box">
      <div className="amount-box-top">
        <h2 className="amount-box-total">
          Total Amount{' '}
          <span className="amount-box-price total-price">
            {' '}
            INR {amount.total}
          </span>
        </h2>
        <p className="amount-box-mun-cost">
          Cost of MUN{' '}
          <span className="amount-box-price">INR {amount.cost}</span>
        </p>
        <p className="amount-box-accomodation">
          Accommodation charges{' '}
          <span className="amount-box-price">INR {amount.charges}</span>
        </p>
        <p className="amount-box-premium">
          Premium charges
          <span className="amount-box-price">INR {amount.premium}</span>
        </p>
        <p className="amount-box-taxes">
          Taxes<span className="amount-box-price">INR {amount.taxes}</span>
        </p>
      </div>
      <div className="amount-box-bottom">
        <button
          className="btn btn-amount-box"
          onClick={() => {
            history.replace('/booking');
          }}
        >
          Edit Details
        </button>
        <StripeCheckout
          stripeKey={process.env.REACT_APP_KEY}
          token={makePayment}
          name="Payment"
          amount={total * 100}
          currency="INR"
        >
          <button className="btn btn-amount-box">Proceed to Pay</button>
        </StripeCheckout>
      </div>
    </div>
  );
}

export default AmountBox;
